import ErrorInputText from "../../../shared/components/ErrorInputText";

const FormInput = ({ title, type, inputProps, attributeProp = {}, error }) => {
  return (
    <div className="flex flex-col space-y-2">
      {title ? <p className="font-bold text-xs md:text-base">{title}</p> : <></>}
      <input
        type={type}
        className="px-3 py-2 border-2 rounded bg-white bg-opacity-40 w-full"
        {...attributeProp}
        {...inputProps}
      />
      <ErrorInputText text={error || ""} />
    </div>
  );
};

export default FormInput;
